module.exports = __webpack_public_path__ + "img/xing.475466c3.png";